export default __webpack_public_path__ + "static/media/VlastaLovelace.6ac1f102.png";